import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-description",
  templateUrl: "./field-set-description.component.html",
})
export class FieldSetDescriptionComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
